import { Project, TypeProjectParticipant } from "../../../../../types/Company";
import { ProjectTeamRole } from "../../../../../types/Projects";
import { getTranslation } from "../../../../../utils/getTranslation";

export type TableTab = "specialists" | "clients" | "team";
export type ProjectTeamMember = NonNullable<Project["team"]>[number];

export const teamRoles = [ProjectTeamRole.MANAGER, ProjectTeamRole.SUPERVISOR];

export const formatTeamRole = (role: ProjectTeamRole | string) =>
  role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();

export const teamRoleOptions = teamRoles.map((role) => ({
  value: role,
  lable: formatTeamRole(role),
}));

export const formatDate = (value?: string) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getRowBgColor = (index: number) =>
  (index + 1) % 2 !== 0 ? "rgba(63, 176, 130, 0.1)" : "rgb(46, 46, 46)";

export const getTeamMemberName = (member: ProjectTeamMember) => {
  const fullName = `${getTranslation(member.user?.name, "en")} ${getTranslation(
    member.user?.surname,
    "en",
  )}`.trim();

  return fullName || member.user?.username || "-";
};

export const isSpecialistRole = (roles: ("employee" | "specialist")[]) => {
  return roles.includes("specialist");
};

export const splitUsersBySpecialty = (
  users: TypeProjectParticipant[],
): TypeProjectParticipant[] => {
  const result: TypeProjectParticipant[] = [];

  for (const user of users) {
    if (user && user.specialistIds && user.specialistIds.length > 0) {
      for (const specialist of user.specialistIds) {
        result.push({
          _id: user._id,
          email: user.email || "",
          name: user.name || [],
          surname: user.surname || [],
          specialistIds: [specialist],
          roles: user.roles,
          shortId: user.shortId,
        });
      }
    } else {
      result.push(user);
    }
  }

  return result;
};
